import { ComposerSection, ComposerSectionProps } from '../types';

/**
 * Type guard to check if a given object is a valid ComposerSection.
 *
 * A ComposerSection must:
 * - Be a function (React component)
 * - Have a 'craft' property with the expected structure
 *
 * @param part - The object to check
 * @returns True if the object is a valid ComposerSection
 */
export const isComposerSection = (part: any): part is ComposerSection<ComposerSectionProps> => {
  if (!part) return false;
  if (typeof part !== 'function') return false;
  if (!part.craft || typeof part.craft !== 'object') return false;

  const craft = part.craft;
  return (
    !!craft.props &&
    typeof craft.props === 'object' &&
    typeof craft.props.sectionType === 'string' &&
    craft.props.sectionType.trim().length > 0 &&
    !!craft.related &&
    typeof craft.related === 'object' &&
    !!craft.related.output &&
    typeof craft.related.output === 'function' &&
    !!craft.related.settings &&
    typeof craft.related.settings === 'function'
  );
};
